module.exports = __webpack_public_path__ + "img/OFFLINEPAY.png?b0bff96e2e3be9bbe80386406874b249";